<template>
  <base-modal
    :is-opened="props.isOpened"
    class="tutorial-course-modal"
    @close="close"
  >
    <h3 class="tutorial-course-modal__title">
      {{ t('modals.tutorialCourseTitle') }}
    </h3>
    <div class="tutorial-course-modal__text">
      <ol>
        <li>
          {{ t('modals.tutorialCourseTextItems[0]') }}
        </li>
        <li>
          {{ t('modals.tutorialCourseTextItems[1]') }}
        </li>
        <li>
          {{ t('modals.tutorialCourseTextItems[2]') }}
        </li>
        <li>
          {{ t('modals.tutorialCourseTextItems[3]') }}
        </li>
      </ol>
    </div>
    <base-button class="tutorial-course-modal__button" @click="confirm">{{
      t('beginNow')
    }}</base-button>
  </base-modal>
</template>

<script setup lang="ts">
import BaseModal from '@/components/modals/BaseModal.vue';
import BaseButton from '@/components/BaseButton.vue';
import { useInternalization } from '@/composables/useInternalization';

const props = defineProps<{
  isOpened: boolean;
}>();

const { t } = useInternalization();

const emit = defineEmits(['close', 'confirm']);

function close() {
  if (props.isOpened) {
    emit('close');
  }
}

function confirm() {
  emit('confirm');
  close();
}
</script>

<style lang="scss" scoped>
.tutorial-course-modal {
  :deep(.modal__container) {
    padding-top: 0;
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    color: #172659;
    text-align: center;
    margin: 0 auto;
  }

  &__text {
    font-size: 15px;
    line-height: 20px;
    color: #172659;
    margin: 16px 0 0;

    li:not(:first-child) {
      margin-top: 16px;
    }
  }

  &__button {
    margin-top: 24px;
  }

  @media (max-width: 720px) {
    :deep(.modal__container) {
      overflow: auto;
    }
  }
}
</style>
